import BaseMapper from '../../BaseMapper';

const OutrightSeasonMapper = (data, context) => {
    return data;
};

export default OutrightSeasonMapper;
